import React from "react";
import "./SystemMessage.scss";

const TypeSystemMessage = (message, sendMessage) => {
  const {tag = '', selectUsers = []} = message;
  
  switch (tag) {
    case 'enter':
      return (
        <div className="system-message-box">
          <strong style={{color: "#0256AD", marginRight:2,cursor:'pointer'}} onClick={()=>sendMessage(selectUsers[0].userId)}>{selectUsers[0].userName}</strong>
          <span style={{color: "#7A7A7A"}}>{' entrou no grupo'}</span>
        </div>
      );
    case 'leave':
      return (
        <div className="system-message-box">
          <span style={{color: "#0256AD", marginRight:2,cursor:'pointer'}} onClick={()=>sendMessage(selectUsers[0].userId)}>{selectUsers[0].userName}</span>
          <span style={{color: "#7A7A7A"}}>{' saiu do grupo'}</span>
        </div>
      );

    case 'remove':
      return (
        <span className="system-message-box">
          <span style={{color: "#0256AD", marginRight:2,cursor:'pointer'}} onClick={()=>sendMessage(selectUsers[0].userId)}>{selectUsers[0].userName}</span>
          <span style={{color: "#7A7A7A"}}>{' removeu '}</span>
          <span style={{color: "#0256AD", marginRight:2,cursor:'pointer'}} onClick={()=>sendMessage(selectUsers[0].userId)}>{selectUsers[1].userName}</span>
          <span style={{color: "#7A7A7A"}}>{' do grupo'}</span>
        </span>
      );
    case 'enterVarious':
      return (
        <span className="system-message-box">
          <span style={{color: "#0256AD", marginRight:2,cursor:'pointer'}}>{selectUsers[0].userName + ', ' + selectUsers[1].userName}</span>
          {selectUsers.length > 2 ? (
            <>
              <span style={{color: "#7A7A7A"}}>{' e mais '}</span>
              <span style={{color: "#0256AD", marginRight:2,cursor:'pointer'}}>{selectUsers.length - 2} pessoas</span>
            </>
          ) : null}
          <span style={{color: "#7A7A7A"}}>{' entraram no grupo'}</span>
        </span>
      );
    case 'delete':
      return (
        <span className="system-message-box">
          <span style={{fontFamily: 'Open Sans', color: '#2A3841', fontSize: 12, fontStyle: 'italic'}}>Essa mensagem foi apagada</span>
        </span>
      );
    default:
      break;
  }
};
const SystemMessage = ( {message, currentUserId, sendMessage}) => {
  const renderSystemMessage = () => {
    let _classRow = "system-message-row", _classBox = "system-message-box", style={};
    if(message.tag === "delete"){
      _classRow = "system-message-row-delete";
      _classBox = 'system-message-box-receiver';
      style ={justifyContent: 'flex-start'};
      if(message.user._id === currentUserId) {
        _classBox = 'system-message-box-send';
        style ={justifyContent: 'flex-end'}
      }  
    }
    return (
      <div className={`${_classRow}`} style={style}>          
        <div className={`${_classBox}`}>
          {TypeSystemMessage(message, sendMessage)}
        </div>
      </div>
    )
  }
 
  return renderSystemMessage() 
};

export default (SystemMessage);
